import { type XSellingDialogProductCardProps } from "@jti/commerce";

import { createTypedMagentoGraphqlClient } from "@/api/magento/graphql";
import { buildProductJsonLdUrl } from "@/components/Product/_internal/buildProductJsonLdUrl";

export const fetchXSellingPopupProducts = async (
  skus: string[],
  locale: string
): Promise<XSellingDialogProductCardProps[]> => {
  if (skus.length === 0) {
    return [];
  }

  const magentoGraphqlClient = createTypedMagentoGraphqlClient({ locale });

  const productsResponse = await magentoGraphqlClient.getProducts({
    sku: skus,
  });

  return skus.flatMap((sku) => {
    const product = productsResponse.products?.items?.find((item) => item?.sku === sku);

    if (!product?.name || !product.url_key) {
      return [];
    }

    const productUrl = buildProductJsonLdUrl({
      locale,
      categoryUrlKey: product.categories?.[0]?.url_path ?? "",
      productUrlKey: product.url_key,
    });

    return [
      {
        sku,
        name: product.name,
        description: product?.short_description?.html || "",
        imgUrl: product?.thumbnail?.url || "",
        imgAlt: product?.thumbnail?.image_alt || product.name,
        productUrl,
        isSimpleProduct: product.__typename === "SimpleProduct",
        isInStock: product.stock_status === "IN_STOCK",
      },
    ];
  });
};
